module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Map/Compass-80edc5b1151681643fd78932c971ba4a11493dcff357b59ff15ff4677a08efb3.svg";